import React from 'react'

const Schedule = () => (
  <div>
    <ul>
      <li>6/5 @ Evergreens</li>
      <li>6/8 vs Kickers</li>
      <li>6/14 @ United</li>
    </ul>
  </div>
)

export default Schedule



// WEBPACK FOOTER //
// ./src/components/Schedule.js